export default "__VITE_ASSET__DYHXpiVy__"